import { NgModule } from '@angular/core';
import { ElementBlockerComponent } from './element-blocker.component';
import { AngularMaterialModule } from '../../angular-material.module';

@NgModule({
  imports: [AngularMaterialModule],
  declarations: [ElementBlockerComponent],
  providers: [],
  exports: [ElementBlockerComponent],
})
export class ElementBlockerModule {
}
